export default [
  {
    name: 'bestellnummer',
    titel: 'Fahrzeugnummer',
  },
  {
    name: 'hersteller_dispo',
    titel: 'Hersteller',
  },
  {
    name: 'modell_dispo',
    titel: 'Modell',
  },
  {
    name: 'gebrauchtyp',
    titel: 'Typ',
  },
  {
    name: 'kilometerstand',
    titel: 'KM',
  },
  {
    name: 'erstzulassung',
    titel: 'EZ',
  },
  {
    name: 'herstellerfarbe',
    titel: 'Farbe',
  },
  {
    name: 'model_text',
    titel: 'Version',
  },
  {
    name: 'listenpreis_upe_brutto',
    titel: 'Listenpreis UPE brutto',
  },
  {
    name: 'wwwpreis',
    titel: 'Hauspreis',
  },
  {
    name: 'leistungkw',
    titel: 'Leistung KW',
  },
  {
    name: 'kraftstoff',
    titel: 'Kraftstoff',
  },
  {
    name: 'batteriekapazitaet',
    titel: 'Batterie-<br>kapazität',
    suffix: ' kWh',
  },
  {
    name: 'fahrgestellnr',
    titel: 'Fahrgestellnummer',
  },
  {
    name: 'aktuelle_abh',
    titel: 'ABH',
  },
  {
    name: 'rechnungsDatum',
    titel: 'Rechnung',
  },
  {
    name: 'standort',
    titel: 'Standort',
  },
];
